var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sku-list',{ref:"SKU_LIST",attrs:{"filterSkuCallback":_vm.filterSkuCallback}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }